import { getLoggedUserToken } from "../tokenStorage";
import {
  handleRefreshFailure,
  isAuthRefreshPaused,
  refreshAccessToken,
} from "./authSession";

const withAuthHeaders = (init?: RequestInit, accessToken?: string | null) => {
  const headers = new Headers(init?.headers);

  if (accessToken) {
    headers.set("authorization", `Bearer ${accessToken}`);
    headers.set("X-Requested-With", "XMLHttpRequest");
  }

  return { ...init, headers };
};

/**
 * fetch() wrapper that attaches the current access token and retries once after refresh on 401.
 */
export const authenticatedFetch = async (
  input: RequestInfo | URL,
  init?: RequestInit
): Promise<Response> => {
  const accessToken = getLoggedUserToken();
  let response = await fetch(input, withAuthHeaders(init, accessToken));

  if (response.status !== 401 || !accessToken || isAuthRefreshPaused()) {
    return response;
  }

  const newToken = await refreshAccessToken();

  if (!newToken) {
    handleRefreshFailure();
    return response;
  }

  return fetch(input, withAuthHeaders(init, newToken));
};

export default authenticatedFetch;
